import { CameraPhoto } from './CameraPhoto';

export { FACING_MODES, IMAGE_TYPES, _getDebugPlatformInfo } from './CameraPhoto';
export * from './plugins';
export default CameraPhoto;



// WEBPACK FOOTER //
// ./src/lib/index.js